import * as React from "react";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import SuccessfulFileList from "./files/successful-file-list";

const PrimaryButton = styled(Button)`
  margin-top: 32px;
  margin-bottom: 60px;
  padding: 8px 24px;
  background-color: #65a300;
  text-transform: none;
  font-weight: 700;
`;

export default function RepresentmentSuccess({
  files,
  fetchState,
  onClickNewRepresentment,
}) {
  return (
    <div>
      <Typography variant="h1">
        <strong>Arquivos enviados</strong>
      </Typography>
      <Typography variant="body1">
        Enviamos um comprovante de recebimento dos arquivos para o email
        cadastrado.
      </Typography>
      <SuccessfulFileList
        title={"Resumo dos arquivos:"}
        files={files}
        fetchState={fetchState}
      />

      <Typography variant="body1">
        Caso ainda tenha dúvidas, nossa central de ajuda possui informações{" "}
        <br /> sobre a{" "}
        <a
          href={
            "https://pagarme.helpjuice.com/pt_BR/p10-seguran%C3%A7a/chargeback-%7C-reapresenta%C3%A7%C3%A3o-de-chargeback"
          }
        >
          contestação de chargeback
        </a>
      </Typography>
      <PrimaryButton
        variant="contained"
        id="new-representment"
        onClick={onClickNewRepresentment}
      >
        Fazer um novo envio
      </PrimaryButton>
    </div>
  );
}
